// NO DEJAR URLS DE LOCALHOST SE ROMPE EL PROYECTO CUANDO SE SUBE A PRODUCCIÓN O DEVELOP
export const environment = {
  production: false,
  firebase: {
    projectId: 'cleversec-encuestas',
    appId: '1:274352004450:web:fb132360b731c0d0ed203b',
    storageBucket: 'cleversec-encuestas.firebasestorage.app',
    apiKey: 'AIzaSyDByXnwr36xmcj9hrCw9DzZw8dBsaPDPlE',
    authDomain: 'cleversec-encuestas.firebaseapp.com',
    messagingSenderId: '274352004450',
    measurementId: 'G-BB043F7P4D',
  },
  prefixSite: 'CE | ',
  urlApi: 'https://ochhz36b1k.execute-api.us-east-1.amazonaws.com/dev/api/v1',
	urlApiInsights: 'https://fq7s0z4yq0.execute-api.us-east-1.amazonaws.com/dev/api/v1/',
  urlApiDevelopment: 'https://cgixa31u5h.execute-api.us-east-1.amazonaws.com/dev/api/v1'
};
